import { apiClient, omrehBaseClient } from "./client";
const GetAll = () => {
    return apiClient
        .get("/Passenger");
}

const Pagination = (data) => {

    return apiClient.post('Passenger/Pagination', {
            "dynamicFilterParams": {
              "filterItems": data.filterItems
            },
            "sortParams": {
              "sortItems": data.sortItems
            },
            "pageSize": data.pageSize,
            "page": data.page
    }
    )
  }

  const GetBrokers=()=>{
    return omrehBaseClient.get('Broker/BrokerDropDown');
  }
  const GetGroupsByBrokerID=(brokerID)=>{
    return omrehBaseClient.get(
      'BrokerGroup/BrokerGroupDropDown',
      {
        params: {
          'BrokerId': brokerID
        }
      }
    );
  }
  const GetHotelInfo=(brockerCode,groupNumber)=>{
    return apiClient.get('Reservation/GetHotelInfo', {
  params: {
    'brockerCode': brockerCode,
    'groupNumber': groupNumber
  }});
  }

const CustomFilter = (data) => {

  return omrehBaseClient.post('Passenger/CustomFilter',
    {
      
      "inputDto": {
        "filters": data.inputDto.filters,
        "orderBy": data.inputDto.orderBy,
        "orderDescending": data.inputDto.orderDescending,
        "pageNumber": data.inputDto.pageNumber,
        "pageSize": data.inputDto.pageSize
      },
      "optionalParams": {
        "from": data.optionalParams.from,
        "to": data.optionalParams.to,
        "nationalCode": data.optionalParams.nationalCode,
        "flightNO": data.optionalParams.flightNO,
        "opration":data.optionalParams.opration
      }
    }
  );
}
const SearchPassenger=(ssn)=>{
return omrehBaseClient.get('Passenger/GetBySSn',{
  params: {
    'Ssn': ssn
  }
})
}

  // const GetTravelInfo=(brockerCode,groupNumber)=>{
  //   return omrehBaseClient.get('TravelInfoGroup/GetTravelInfoWithBrokerNoAndGroupNo', {
  // params: {
  //   'brokerCode': brockerCode,
  //   'groupNo': groupNumber
  // }});
  // }

const passengerApi = {
    GetAll,Pagination,GetHotelInfo,CustomFilter,GetBrokers,GetGroupsByBrokerID,SearchPassenger
}

export default passengerApi